import React, { useState, useEffect, useContext } from 'react'
import { Col, Row, Card, Table, Button, message, Select, Empty, Typography, Icon, Divider, Tag } from 'antd'
import {
    EyeFilled,
    EditFilled,
    WhatsAppOutlined
} from '@ant-design/icons';
import { ContextAPI } from "../../../ContextAPI"
import { platformApi } from '../../../api'
import './style.less'
import moment from 'moment'
import WrappedCallingInterface from "../../FollowUp/QuotationInfo/CallingInterface"
import WrappedMessageInterface from "../../FollowUp/QuotationInfo/MessageInterface"
import WrappedWhatsAppInterface from "../../FollowUp/QuotationInfo/WhatsAppInterface"
import WrappedVehicleForm from "../../TransactionMasters/Vehicles/VehicleForm"
import VehicleName from "../../VehicleName"

const VehicleInfo = (props) => {
    const { dataSource, getCustomerInfo, getActivityByCustomer, customerDetail, customerId, actionStatus, activityType, moduleid, followUpDate } = props
    const { Text, Title } = Typography
    const [vehicleModal, setVehicleModal] = useState(false)
    const [vehicleDetail, setVehicleDetail] = useState(null)
    const [vehicleEditable, setVehicleEditable] = useState(false)
    const [callModal, setCallModal] = useState(false)
    const [messageModal, setMessageModal] = useState(false)
    const [whatsAppMessageModal, setWhatsAppMessageModal] = useState(false)
    const { loginCredintials } = useContext(ContextAPI);
    const [uploading, setUploading] = useState(false)
    const [modifyAccess, setModifyAccess] = useState(false);
    
    // State to store filtered service reminders
    const [filteredServiceReminders, setFilteredServiceReminders] = useState([]);
    const [allServiceReminders, setAllServiceReminders] = useState([]);

    useEffect(() => {
        if (dataSource && dataSource.length > 0) {
            const record = dataSource[0];

            // Extract reminders and jobOrders
            const reminders = record?.serviceReminders || [];
            const jobOrders = record?.jobOrder || [];

            setAllServiceReminders(reminders);

            // ---- Find Latest Job Order ----
            let latestJob = null;
            if (jobOrders.length > 0) {
                latestJob = jobOrders.reduce((latest, job) => {
                    const latestDate = new Date(latest?.createdAt || 0);
                    const currentDate = new Date(job.createdAt);
                    return currentDate > latestDate ? job : latest;
                }, jobOrders[0]);
            }

            // ---- Add last service info ----
            const remindersWithLastJob = reminders.map(reminder => ({
                ...reminder,
                lastServiceDate: latestJob?.createdAt || null,
                lastServiceKm: latestJob?.kms || null,
                lastServiceType: latestJob?.serviceType || null,
            }));

            // ---- Filter by followUpDate ----
            if (followUpDate) {
                const followUpDateObj = new Date(followUpDate);
                const followUpUTC = followUpDateObj.toISOString().split("T")[0];

                const filteredReminders = remindersWithLastJob.filter(reminder => {
                    if (!reminder.serviceDate) return false;
                    const reminderUTC = new Date(reminder.serviceDate).toISOString().split("T")[0];
                    return followUpUTC === reminderUTC;
                });

                setFilteredServiceReminders(filteredReminders);
            } else {
                setFilteredServiceReminders(remindersWithLastJob);
            }
        } else {
            setAllServiceReminders([]);
            setFilteredServiceReminders([]);
        }
    }, [dataSource, followUpDate]);


    const column = [
        {
            title: <Text strong>Model Name</Text>,
            dataIndex: "vehicle",
            key: "name",
            render: (record) => (
                <VehicleName nameOnly value={record} />
            )
        },
        {
            title: <Text strong>Registration No</Text>,
            dataIndex: "registerNo",
            key: "regno",
            render: (record) => (record ? <span>{record}</span> : <span>-</span>)
        },
        {
            title: <Text strong>Created On</Text>,
            dataIndex: "createdAt",
            key: "createdAt",
            render: (record) => <span>{record ? moment(new Date(record)).format('DD/MM/YYYY') : '-'}</span>,
        },
        ...(actionStatus ? [{
            title: <Text strong>Action</Text>,
            dataIndex: "id",
            align: 'center',
            key: "id",
            render: (record) => <EyeFilled style={{ textAlign: 'center' }} onClick={() => viewVehicle(record)} />,
        }] : [])
    ]

    // Service Reminders Table Columns
    const serviceReminderColumns = [
        {
            title: <Text strong>Service No</Text>,
            dataIndex: "serviceNo",
            key: "serviceNo",
            render: (record) => <span>{record || '-'}</span>
        },
        {
            title: <Text strong>Service Type</Text>,
            dataIndex: "serviceType",
            key: "serviceType",
            render: (record) => {
                let color = 'blue';
                if (record === 'FREE') color = 'green';
                if (record === 'PAID') color = 'orange';
                
                return <Tag color={color}>{record || '-'}</Tag>;
            }
        },
        {
            title: <Text strong>Service Date</Text>,
            dataIndex: "serviceDate",
            key: "serviceDate",
            render: (record) => (
                <span>
                    {record ? moment(new Date(record)).format('DD/MM/YYYY') : '-'}
                </span>
            )
        },
        {
            title: <Text strong>Service Kms</Text>,
            dataIndex: "serviceKms",
            key: "serviceKms",
            render: (record) => <span>{record ? `${record}` : '-'}</span>
        },
        {
            title: <Text strong>Last Service Date</Text>,
            dataIndex: "lastServiceDate",
            key: "Last Service Date",
            render: (record) => (
                <span>
                    {record ? moment(new Date(record)).format('DD/MM/YYYY') : '-'}
                </span>
            )
        },
        {
            title: <Text strong>Last Service Kms</Text>,
            dataIndex: "lastServiceKm",
            key: "Last Service Kms",
            render: (record) => <span>{record ? `${record}` : '-'}</span>
        },
        {
            title: <Text strong>Last Service Type</Text>,
            dataIndex: "lastServiceType",
            key: "Last Service Type",
            render: (record) => <span>{record ? `${record}` : '-'}</span>
        },
        {
            title: <Text strong>Status</Text>,
            dataIndex: "status",
            key: "status",
            render: (record) => {
                let statusColor = 'default';
                if (record === 'INPROGRESS') statusColor = 'orange';
                if (record === 'COMPLETED') statusColor = 'green';
                if (record === 'PENDING') statusColor = 'red';
                
                return (
                    <Tag color={statusColor}>
                        {record || '-'}
                    </Tag>
                );
            }
        }
    ];

    const viewVehicle = (vehicleId) => {
        getVehicle(vehicleId)
        setVehicleModal(true);
    }
    
    const getVehicle = (vehicleId) => {
        return new Promise(async (resolve, reject) => {
            await platformApi.get(`/api/vehicle/${vehicleId}`).then(res => {
                const { data: { response: { data } } } = res;
                setVehicleDetail(data)
                resolve(data)
            })
        })
    }

    const addData = (formData, vehicle) => {
        if (vehicle.id) {
            platformApi
                .put('/api/vehicle/' + vehicle.id, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((result) => {
                    setSpinning(false);
                    let { data } = result;
                    if (data.code === 200) {
                        let { response } = data;
                        if (response.code === 200) {
                            message.success('Vehicle saved successfully', 2);
                        } else {
                            message.error('Unable to save vehicle', 2);
                        }
                    } else {
                        message.error('Unable to save vehicle', 2);
                    }
                })
                .catch((error) => {
                    console.error('Error on Vehicles : ', error);
                    message.error('Unable to save vehicle', 2);
                });
        }
        else {
            platformApi
                .post('/api/vehicle', formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((result) => {
                    let { data } = result;
                    if (data.code === 200) {
                        let { response } = data;
                        if (response.code === 200) {
                            message.success('Vehicle added successfully', 2);
                        } else {
                            message.error('Unable to add vehicle', 2);
                        }
                    } else {
                        message.error('Unable to add vehicle', 2);
                    }
                })
                .catch((error) => {
                    console.error('Error on Vehicles : ', error);
                    message.error('Unable to add vehicle', 2);
                });
        }
    };

    return (
        <div className="quotation-info">
            <Card style={{ minHeight: '220px' }}>
                <Row type="flex" justify="space-between" gutter={[16, 16]}>
                    <Col span={18}>
                        <Row type="flex" justify="space-between" gutter={[16, 16]}>
                            <Col span={24}>
                                <Table
                                    locale={{
                                        emptyText: (
                                            <Empty
                                                imageStyle={{
                                                    height: 25,
                                                    fontSize: 30,
                                                }}
                                                description={(
                                                    <Text disabled strong>
                                                        No Vehicles Associated
                                                    </Text>
                                                )}
                                            />
                                        ),
                                    }}
                                    rowKey={(record) => record.id}
                                    pagination={false}
                                    size="small"
                                    columns={column}
                                    dataSource={dataSource}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <Row type="flex" gutter={[16, 16]} justify='space-between'>
                            <Col>
                                <Button style={{ width: '100px' }} onClick={() => setCallModal(true)}>
                                    <Icon type="phone" />
                                </Button>
                            </Col>
                            <Col>
                                <Button style={{ width: '100px' }} onClick={() => setWhatsAppMessageModal(true)}>
                                    <WhatsAppOutlined />
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    
                    {/* Service Reminders Table Section - Filtered by followUpDate */}
                    {filteredServiceReminders.length > 0 && (
                        <Col span={24}>
                            <Divider orientation="left" style={{ marginTop: '20px', marginBottom: '10px' }}>
                                <Text strong>
                                    Service Reminders for {followUpDate ? moment(new Date(followUpDate)).format('DD/MM/YYYY') : 'Selected Date'}
                                </Text>
                            </Divider>
                            <Table
                                rowKey={(record) => record.id}
                                pagination={false}
                                size="small"
                                columns={serviceReminderColumns}
                                dataSource={filteredServiceReminders}
                                style={{ marginTop: '10px' }}
                            />
                        </Col>
                    )}
                </Row>
            </Card>
            <WrappedMessageInterface
                visibility={messageModal}
                customerDetail={customerDetail}
                type={"serviceFollowup"}
                getCustomerInfo={getCustomerInfo}
                getActivityByCustomer={getActivityByCustomer}
                setVisibility={setMessageModal}
            />
            <WrappedWhatsAppInterface
                visibility={whatsAppMessageModal}
                customerDetail={customerDetail}
                type={"serviceFollowup"}
                getCustomerInfo={getCustomerInfo}
                getActivityByCustomer={getActivityByCustomer}
                setVisibility={setWhatsAppMessageModal}
            />
            <WrappedCallingInterface
                visibility={callModal}
                type={"serviceFollowup"}
                customerDetail={customerDetail}
                getActivityByCustomer={getActivityByCustomer}
                setVisibility={setCallModal}
                activityType={activityType}
                moduleid={moduleid}
            />
            <WrappedVehicleForm
                data={vehicleDetail}
                emitData={addData}
                open={vehicleModal}
                editable={vehicleEditable}
                setUploading={setUploading}
                uploading={uploading}
                close={() => {
                    setVehicleModal(false);
                    setUploading(false);
                }}
                modify={modifyAccess}
                edit={modifyAccess}
                setEdit={setModifyAccess}
                vData={false}
            />
        </div>
    )
}
export default VehicleInfo;